import { Col, DatePicker, Form, Input, InputNumber, Radio, Row } from 'antd'
import React, { useState } from 'react'
import { t } from 'i18next'
import TextArea from 'antd/es/input/TextArea'
import PhoneInput from 'react-phone-number-input'
import ZipCodeSearchField from '../../Public/Appointment/ZipCodeSearchField'
import { ConsultationStateTag } from '../TagsPage/StateTag'
const { RangePicker } = DatePicker

export default function AppointmentForm ({ form, onFinish, edit, rangeDisable, postalPlace, disabled = false, specialist = false, appointment = null }) {
  const [ageRequired, setAgeRequired] = useState(true)
  const onDateChange = (value) => {
    if (value[0].isSame(value[1])) {
      form.setFieldsValue({ range: [value[0], value[1].add(1, 'hour')] })
    }
    form.setFieldsValue({ appointment_date: value[0] })
  }

  return (
    <Form
      id="AppointmentFormAdmin"
      size='small'
      form={form}
      labelAlign='left'
      layout='vertical'
      onFinish={onFinish}
      disabled={disabled}
    >
      <Form.Item name="is_now" hidden />

      <Form.Item name="type"
        rules={[{ required: true, message: t('rules.required') }]}
      >
        <Radio.Group disabled={edit} onChange={(e) => { setAgeRequired(e.target.value === 'PatientAppointment') }}>
          <Radio value='PatientAppointment'>{t('Admin.Appointment.type.PatientAppointment')}</Radio>
          <Radio value='MaintenanceAppointment'>{t('Admin.Appointment.type.MaintenanceAppointment')}</Radio>
          <Radio value='WorkAppointment'>{t('Admin.Appointment.type.WorkAppointment')}</Radio>
          <Radio value='CleaningAppointment'>{t('Admin.Appointment.type.CleaningAppointment')}</Radio>
        </Radio.Group>
      </Form.Item>
      {edit &&
        <Row gutter={16}>
          <Col>
            <Form.Item name="box_data" label={t('Admin.AppointmentForm.box')}>
              <Input disabled={true} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="interphone" label={t('Admin.AppointmentForm.interphone')}>
              <Input disabled={true} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="assigned" label={t('Admin.AppointmentForm.assigned')}>
              <Input disabled={true} />
            </Form.Item>
          </Col>
          {appointment && <Col> <Form.Item name="consultation_done" label={t('Admin.AppointmentForm.consultation_done')}>
            <ConsultationStateTag appointment={appointment} />
          </Form.Item></Col>}
          {appointment && <Col> <Form.Item name="note" label={t('Admin.AppointmentForm.note')}>
            <Input disabled={true} />
          </Form.Item>
          </Col>}
          <Col>
            <Form.Item name="created_by" label={t('Admin.AppointmentForm.createdBy.label')}>
              <Input disabled={true} />
            </Form.Item>
          </Col>
        </Row>
      }
      <Row gutter={16}>
        <Col>
          <Form.Item name="created_at" label={t('Admin.AppointmentForm.created_at')}>
            <DatePicker disabled={true} format={'DD/MM/YY HH[h]mm'} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="range" label={t('Admin.AppointmentForm.range')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <RangePicker
              onChange={onDateChange}
              showTime={{ format: 'HH[h]mm' }}
              format={'DD/MM/YY HH[h]mm'}
              disabled={rangeDisable} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="appointment_date" label={t('Admin.AppointmentForm.appointment_date')} >
            <DatePicker
              format={'DD/MM/YY HH[h]mm'}
              disabled />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        {edit && <Col>
          <Form.Item name="digicode" label={t('Admin.AppointmentForm.digicode')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input />
          </Form.Item>
        </Col>}
        {edit && specialist &&
          <Col span={10}>
            <Form.Item name="specialist_name" label={t('Admin.AppointmentForm.specialistName')} >
              <Input disabled />
            </Form.Item>
          </Col>
        }
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="first_name" label={t('Admin.AppointmentForm.first_name')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="last_name" label={t('Admin.AppointmentForm.last_name')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="age" label={t('Admin.AppointmentForm.age')}
            extra={t('Admin.AppointmentForm.age_extra')} >
            <InputNumber min={0} max={150} disabled={!ageRequired} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col style={{ maxWidth: '25%' }}>
          <Form.Item name="phone" label={t('Admin.AppointmentForm.phone')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <PhoneInput className='ant-input css-dev-only-do-not-override-xfszwz' disabled={disabled}
              international defaultCountry={'FR'}
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="email" label={t('Admin.AppointmentForm.email')}>
            <Input />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="postal_place_id" label={t('Admin.AppointmentForm.zip_code')}>
            <ZipCodeSearchField form={form} initialPostalPlace={postalPlace} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="comment" label={t('Admin.AppointmentForm.comment')}>
        <TextArea rows={5} />
      </Form.Item>
    </Form>
  )
}
